var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TypesenseSearchService, shouldEnableInfix } from '../../../infra/search';
var CustomerSearchService = /** @class */ (function (_super) {
    __extends(CustomerSearchService, _super);
    function CustomerSearchService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSearchService.prototype.buildSearchParams = function (payload) {
        var _a;
        var tags = [];
        tags.push(payload.ownerShop.id);
        if ((_a = payload.ownerShop.brand) === null || _a === void 0 ? void 0 : _a.showBrandCustomersToShops) {
            tags.push(payload.ownerShop.brand.id);
        }
        return {
            q: payload.searchString,
            query_by: 'name,phone,email',
            filter_by: "tags:=[".concat(tags.join(','), "] && type:=customer"),
            infix: shouldEnableInfix(payload.searchString) ? 'fallback' : 'off',
        };
    };
    return CustomerSearchService;
}(TypesenseSearchService));
export { CustomerSearchService };
